const dateDiff = (day1, day2) => {
    const diff = new Date(day1 - day2);

    const dateDiffMinutes = Math.round(diff.getTime() / 1000 / 60);
    const dateDiffHours = Math.round(diff.getTime() / 1000 / 60 / 60);
    const dateDiffDay = Math.round(diff.getTime() / 1000 / 60 / 60 / 24);

    if (dateDiffHours <= 24 && dateDiffDay < 1) {
        if (dateDiffMinutes < 60 && dateDiffHours < 1) {
            return 'há alguns minutos';
        } else {
            return 'há ' + dateDiffHours + ' horas';
        }
    } else if (dateDiffDay <= 15) {
        return 'há ' + dateDiffDay + ' dias';
    } else {
        return day2.toLocaleDateString('pt-BR').toString();
    }
};

const formatStringDateUsingLocale = (dateString, locale) => {
    if (!dateString) return '-';

    let date;
    const parts = dateString.split(/[-/]/);

    // Try to parse the date - dd/MM/yyyy or yyyy-MM-dd
    if (dateString.includes('-')) {
        // Assume yyyy-MM-dd format
        const [year, month, day] = parts;
        date = new Date(year, month - 1, day);
    } else if (dateString.includes('/')) {
        // Assume dd/MM/yyyy format
        const [day, month, year] = parts;
        date = new Date(year, month - 1, day);
    }

    if (!date || isNaN(date.getTime())) {
        return dateString; // Return as-is if parsing fails
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    if (locale === 'pt-br' || locale === 'es') {
        return `${day}/${month}/${year}`;
    } else if (locale === 'en') {
        return `${month}/${day}/${year}`;
    }

    return `${day}/${month}/${year}`; // default to dd/MM/yyyy
};

export default {
    dateDiff,
    formatStringDateUsingLocale
};
